import { Separator } from '../../primitives'

import './index.scss'

const LineSeparator = () => <Separator className='Separator__Line' />

export default LineSeparator
